import { Tabs } from "@mantine/core";

const TabsCustomer = ({ defaultValue, tabs }: any) => {
  return (
    <Tabs
      styles={{
        root: {
          background: "#FDFDFD",
          borderRadius: "8px",
          boxShadow: "0px 2px 8px 0px #638DBF1A",
          margin: "24px 0px",
        },
      }}
      defaultValue={defaultValue}
    >
      <Tabs.List style={{ borderBottom: "2px solid transparent" }}>
        {tabs.map((item: any) => {
          return (
            <Tabs.Tab
              sx={(theme) => ({
                height: "64px",
                fontSize: 16,
                borderBottom: "2px solid transparent",
                "&:hover": {
                  borderBottom: "2px solid #2A81D0",
                },
                "&[data-active]": {
                  color: "#2A81D0",
                  fontWeight: 600,
                  borderBottom: `2px solid #2A81D0`,
                },
                "&[data-active]:hover": {
                  borderBottom: `2px solid #2A81D0`,
                },
              })}
              value={item.value}
            >
              {item.label}
            </Tabs.Tab>
          );
        })}
      </Tabs.List>

      {tabs.map((item: any) => {
        return <Tabs.Panel value={item.value}>{item.panelContent}</Tabs.Panel>;
      })}
    </Tabs>
  );
};
export default TabsCustomer;
